import React from 'react'
import styles from './styles.module.css'

export default class LoadingProducts extends React.Component {
  static propTypes = {}

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.category}>
          <div className={styles.name} />
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <div className={styles.product} />
            </div>
            <div className="col-xs-12 col-md-6">
              <div className={styles.product} />
            </div>
            <div className="col-xs-12 col-md-6">
              <div className={styles.product} />
            </div>
            <div className="col-xs-12 col-md-6">
              <div className={styles.product} />
            </div>
          </div>
        </div>
        <div className={styles.category}>
          <div className={styles.name} />
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <div className={styles.product} />
            </div>
            <div className="col-xs-12 col-md-6">
              <div className={styles.product} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}
